import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class RestoreEnvService {
    async restoreLiveToTest(fromClientId: number, toClientId: number, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/RestoreEnv/restorelivetotest`;
        if (environmentName) {
            url += `?environmentName=${encodeURIComponent(environmentName)}`;
        }
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sourceClientId: fromClientId, 
                targetClientId: toClientId
            })
        });
        
        const responsejson = await response.json();
        
        if (!response.ok) {
            throw new Error();
        }
        
        return responsejson;
    }

    async getRestoreLiveToTestStatus(taskId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/RestoreEnv/restorelivetoteststatus/${taskId}`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return response.json();
    }

    async linkDatabase(appGroupName: string, fullDatabaseName: string, customerName: string, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/RestoreEnv/linkdatabase`;
        if (environmentName) {
            url += `?environmentName=${encodeURIComponent(environmentName)}`;
        }
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                appGroupName,
                fullDatabaseName,
                customerName
            })
        });

        if (!response.ok) {
            throw new Error(`An error has occured, please check network/activity logs.`);
        }

        return response.json();
    }
}

export default new RestoreEnvService();
